export const USER_SET_INITIAL_STATE = 'USER_SET_INITIAL_STATE';
export const USER_FIND_ALL = 'USER_FIND_ALL';
export const USER_VIEW = 'USER_VIEW';
